<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Επιθεωρητές - Ποσά</h4>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CButton
            color="primary"
            class="mb-2"
            @click="xlsCode"
            target="_blank"
          >
            Download (.xls)
          </CButton>
          <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            @row-clicked="(item) => showInspector(item.id)"
            clickable-rows
          >
          <template #owed_price="{item}">
            <td>
              {{ item.owed_price }}€
            </td>
          </template>
          <template #paid_price="{item}">
            <td>
              {{ item.paid_price }}€
            </td>
          </template>
          <template #total_price="{item}">
            <td>
              {{ item.total_price }}€
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon"
                @click.stop="editInspector( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import js2excel from 'js2excel';

const fields = [
  {
    key: 'name', 
    label: 'Ονοματεπώνυμο', 
    sorter: true, 
    filter: true
  },
  {
    key: 'owed_price', 
    label: 'Οφειλές', 
    sorter: true, 
    filter: true
  },
  {
    key: 'paid_price', 
    label: 'Εξοφλημένο Ποσό', 
    sorter: true, 
    filter: true
  },
  {
    key: 'total_price',
    label: 'Συνολικό Ποσό',
    sorter: true,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'InspectorsFinanceReports',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      message: '',
      showMessage: false,
      alertIsShown: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      loading: true,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    xlsCode () {
      this.tempArr = this.items.map((item) => {
        return {
          Ονοματεπώνυμο: item.name,
          Οφειλές: item.owed_price+'€',
          'Εξοφλημένο Ποσό': item.paid_price+'€',
          'Συνολικό Ποσό': item.total_price+'€'
        }
      });

      try {
        js2excel.json2excel({
            data: this.tempArr,
            name: 'inspectors-finance-data',
            formateDate: 'dd/mm/yyyy'
        });
      } catch (e) {
          console.error('export error: ', e);
      }
    },
    inspectorLink (id) {
      return `inspectors/${id.toString()}`
    },
    editLink (id) {
      return `inspectors/${id.toString()}/edit`
    },
    showInspector ( id ) {
      const inspectorLink = this.inspectorLink( id );
      this.$router.push({path: inspectorLink});
    },
    editInspector ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getInspectorReports (){
      let self = this;

      axios.get('/api/inspectors/get_inspectors_finances?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.inspectors;
        console.log(self.items);
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
  },
  mounted: function(){
    this.getInspectorReports();
  }
}
</script>